import get_tiles_configuration from "@/data/tiles";

const active_property_storage_key = "bolide_active_property_context";

export default {
  data() {
    return ({
      sidebar_tiles: [],
      sidebar_active_property: null,
      sidebar_active_item: "shaft-dashboard",
    });
  },

  computed: {
    sidebar_can_view_portfolio() {
      // Every authenticated Siyanda Platinum user sees the full portfolio.
      return true;
    },
  },

  created() {
    this.load_sidebar_context();
  },

  methods: {
    load_sidebar_context() {
      this.sidebar_tiles = get_tiles_configuration();
      const context = this.read_sidebar_property_context();
      this.sidebar_active_property = this.sidebar_tiles.find((tile) => {
        return String(tile.id) === String(context?.id)
          || String(tile.title) === String(context?.title);
      }) || null;
      this.sidebar_active_item = context?.menuItem || "shaft-dashboard";
    },

    read_sidebar_property_context() {
      return JSON.parse(sessionStorage.getItem(active_property_storage_key) || "null");
    },

    open_sidebar_property(tile_id, menu_item = "shaft-dashboard") {
      const tile = this.sidebar_tiles.find((item) => item.id === tile_id);
      if (tile) {
        sessionStorage.setItem(active_property_storage_key, JSON.stringify({
          id: tile.id,
          title: tile.title,
          menuItem: menu_item,
        }));
      }
      this.$router.push("/home");
    },

    open_sidebar_property_menu(data) {
      this.open_sidebar_property(data.propertyId, data.menuItem);
    },

    open_sidebar_portfolio() {
      sessionStorage.removeItem(active_property_storage_key);
      this.$router.push("/home");
    },
  },
};
